(function(window, document) {

    // function imageOptimization() {
    //     const images = document.querySelectorAll('.itg_data[itg-src]');
    //     if (images.length === 0) return; 

    //     images.forEach(img => {
    //         img.src = img.getAttribute('itg-src');
    //         img.removeAttribute('itg-src');
    //     });
    // }
    
    // ['scroll', 'mousemove', 'touchstart', 'click'].forEach(event =>
    //     document.addEventListener(event, imageOptimization, { passive: true })
    // );
    // window.imageOptimization = imageOptimization;

    function designDetailsSlider(){
        var swiper = new Swiper(".design-details-slider", {
                      slidesPerView: 2,    
                      slidesPerGroup: 2,      
                      spaceBetween: 30,  
                      speed: 800,
                      loop: true,   
                      loopFillGroupWithBlank: true,
                      navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                      },
                      breakpoints: {
                        // when window width is >= 320px
                        320: {
                          slidesPerView: 1,
                          slidesPerGroup: 1,
                          spaceBetween: 10,
                        },
                        // when window width is >= 640px
                        768: {
                          slidesPerView: 1,
                          slidesPerGroup: 1,
                          spaceBetween: 30,
                        },
                        991: {
                          slidesPerView: 2,
                          slidesPerGroup: 2,
                          spaceBetween: 30,
                        },
                        // when window width is >= 1024px
                        1024: {
                          slidesPerView: 2,
                          slidesPerGroup: 2,
                          spaceBetween: 30,
                        }
                      }
                    });
    }

     window.designDetailsSlider = designDetailsSlider;

     function storySliderMain(){
      var StorySlider = new Swiper(".story_slider_main", {
        slidesPerView: 1,    
        slidesPerGroup: 1, 
        speed: 800,     
        spaceBetween: 0,  
        loop: true,   
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      });
    }

     window.storySliderMain = storySliderMain;

     function sliderMainIamges(){
       const swiper = new Swiper('.slider_main_iamges', {
        loop: true, // infinite loop
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.arrow_slider.swiper-button-next',
          prevEl: '.arrow_slider.swiper-button-prev',
        },
        on: {
          slideChange: function () {
            const prevButton = document.querySelector('.ddsdsdsds');
            if (this.realIndex === 0) {
              prevButton.style.display = 'none';
            } else {
              prevButton.style.display = '';
            }
          },
        },
      });
    }
    window.sliderMainIamges = sliderMainIamges;

function initializeScrollNav() {
  const navLinks = document.querySelectorAll(".link_tab_nav");
  const sections = Array.from(navLinks).map(link => document.querySelector(link.getAttribute("href")));
  const productDetails = document.querySelector("#productDetails");

  function onScroll() {
    const productRect = productDetails.getBoundingClientRect();
    if (productRect.bottom > 0) {
      return;
    }

    let currentSectionId = null;

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const rect = section.getBoundingClientRect();

      if (rect.top <= 100 && rect.bottom >= 100) {
        currentSectionId = section.getAttribute("id");
        break;
      }
    }

    navLinks.forEach(link => {
      if (link.getAttribute("href") === `#${currentSectionId}`) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  }

  window.addEventListener("scroll", onScroll);
  onScroll(); // Run once on init
}

    window.initializeScrollNav = initializeScrollNav;


})(window, document);

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes("/products")) {
    window.sliderMainIamges();
    window.designDetailsSlider();
    window.storySliderMain();
    window.initializeScrollNav();
  }
  const menuBtn = document.querySelector('.site-nav__menu button');
  if (!menuBtn) return;

  menuBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const dropdown = document.querySelector('.site-header__mobile-dropdown');
    const icon = menuBtn.querySelector('.icon');
    const isActive = dropdown.classList.contains('dropdown--active');

    if (!isActive) {
      dropdown.style.display = 'block';
      dropdown.classList.add('dropdown--active');
      document.body.classList.add('js-drawer-open');
      document.documentElement.classList.add('js-drawer-open');
      icon.classList.replace('icon-hamburger', 'icon-x');
    } else {
      dropdown.style.display = 'none';
      dropdown.classList.remove('dropdown--active');
      document.body.classList.remove('js-drawer-open');
      document.documentElement.classList.remove('js-drawer-open');
      icon.classList.replace('icon-x', 'icon-hamburger');
    }
  });

});

function onSdkReady() {
    const reviewTop = document.querySelector('.average_review_top');
    if (reviewTop) {
        reviewTop.addEventListener('click', function() {
            const reviewsDiv = document.querySelector('#reviews');
            if (reviewsDiv) {
                const topPos = reviewsDiv.getBoundingClientRect().top + window.scrollY - 200;
                window.scrollTo({
                    top: topPos,
                    behavior: 'smooth'
                });
            }
        });
    } else {
    }
}


if (window.gw && window.gw.sdk) {
   setTimeout(() => {
        onSdkReady();
   }, 1000);
} else {
    document.addEventListener("gwSdkReady", onSdkReady);
}







document.addEventListener('DOMContentLoaded', function() {
  // ✅ Dawn main section selector
  const announcement = document.querySelector('#shopify-section-announcement-bar, .shopify-section--announcement-bar, .announcement-bar');
  if (!announcement) return;

  // Helper to get visible height
  function getVisibleHeight(el) {
    const rect = el.getBoundingClientRect();
    const visible = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    return Math.max(0, visible);
  }

  // Scroll handler
  function handleScroll() {
    const visibleHeight = getVisibleHeight(announcement);
    // Debug check:
    // console.log('Visible height:', visibleHeight);

    // Example: store global variable
    window.announcementVisibleHeight = visibleHeight;

    
    

    const megaMenus = document.querySelectorAll('.mega-menu-section');
    megaMenus.forEach(menu => {
      const headerGroup = document.querySelector('.section-header');
      const isSticky = headerGroup && headerGroup.classList.contains('shopify-section-header-sticky');

      if (!isSticky) {
        if (visibleHeight > 0) {
          menu.style.top = (visibleHeight + 129.25) + 'px';
        } else {
          menu.style.top = '129.25px';
        }
      } else {
        menu.style.top = 'unset';
      }
    });

  }

  // Throttle (for performance)
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Listen to every scroll type
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('wheel', onScroll, { passive: true });
  window.addEventListener('touchmove', onScroll, { passive: true });

  // Initial run (page load)
  handleScroll();


  const links = document.querySelectorAll('.scroll_main');
  if (links.length > 0) {
    links.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const target = document.getElementById('product_details');
        if (target) { 
          const headerHeight = 53;
          const topPos = target.offsetTop - headerHeight;
          window.scrollTo({
            top: topPos,
            behavior: 'smooth'
          });
        }
      });
    });
  }

window.addEventListener("scroll", function () {
    const banner = document.querySelector(".product-banner-new-launch");
    const stickyDiv = document.querySelector(".product_single_section_navbar");
    if (!banner || !stickyDiv) return;
    const bannerEnd = banner.offsetTop + banner.offsetHeight;
    const scrollY = window.scrollY;
    if (scrollY > bannerEnd) {
        stickyDiv.classList.add("is-sticky");
    } else {
        stickyDiv.classList.remove("is-sticky");
    }
});

const navLinks = document.querySelectorAll(".link_tab_nav");

if (navLinks.length > 0) {            // CONDITION 1 → Agar nav links hai tabhi run karo

  const sections = Array.from(navLinks).map(link =>
    document.querySelector(link.getAttribute("href"))
  ).filter(sec => sec !== null);      // CONDITION 2 → Null sections hatao

  if (sections.length > 0) {          // CONDITION 3 → Agar sections mil gaye tabhi scroll ka code chalao

    window.addEventListener("scroll", () => {
      let currentSectionId = null;

      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        const rect = section.getBoundingClientRect();

        // CONDITION 4 → Section visible area me ho
        if (rect.top <= 100 && rect.bottom >= 100) {
          currentSectionId = section.getAttribute("id");
          break;
        }
      }

      navLinks.forEach(link => {
        if (link.getAttribute("href") === `#${currentSectionId}`) {
          link.classList.add("active");
        } else {
          link.classList.remove("active");
        }
      });

    });

  }

}

document.addEventListener("click", function(event) {
  const anchorButton = event.target.closest(".link_tab_nav");
  if (!anchorButton) return;
  event.preventDefault();
  document.querySelectorAll(".link_tab_nav.active").forEach(function(btn) {
    btn.classList.remove("active");
  });

  anchorButton.classList.add("active");
  const dataId = anchorButton.getAttribute("data-id");
  const targetSection = document.getElementById(dataId);

  if (!targetSection) return;
  const sectionTop = targetSection.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: sectionTop - 90,
    behavior: "smooth"
  });
});

document.addEventListener('click', function (e) {
  const finalButton = e.target.closest('.product-single__submit_final');
  const submitButton = document.querySelector('.custom_btn_product');
  if (finalButton && submitButton) {
    finalButton.classList.add('clicked');
    submitButton.click();
    setTimeout(function () {
      finalButton.classList.remove('clicked');
    }, 1000);
  }
});


});
